import { render, staticRenderFns } from "./Payment-Result.vue?vue&type=template&id=38d45092&scoped=true&"
import script from "./Payment-Result.vue?vue&type=script&lang=js&"
export * from "./Payment-Result.vue?vue&type=script&lang=js&"
import style0 from "./Payment-Result.vue?vue&type=style&index=0&id=38d45092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d45092",
  null
  
)

export default component.exports